import { render, staticRenderFns } from "./DetailsRxGoldCard.vue?vue&type=template&id=1c3ad374"
import script from "./DetailsRxGoldCard.vue?vue&type=script&lang=js"
export * from "./DetailsRxGoldCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports